import { render } from "./SpvUpload.vue?vue&type=template&id=0267d112&scoped=true"
import script from "./SpvUpload.vue?vue&type=script&lang=js"
export * from "./SpvUpload.vue?vue&type=script&lang=js"

import "./SpvUpload.vue?vue&type=style&index=0&id=0267d112&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0267d112"]])

export default __exports__